import { tss } from 'tss-react/mui';

const useStyles = tss.create(() => ({
  activationCodeBtn: {
    borderRadius: '0 .25rem .25rem 0'
  },
  KVFlex: {
    display: 'flex',
    margin: '0.625rem 0',
    gap: '.5rem',
    alignItems: 'center'
  },
  dFlex: {
    display: 'flex',
    flex: 0.6,
    inlineSize: '10.625rem',
    wordWrap: 'break-word',
    alignItems: 'center'
  },
  token: {
    whiteSpace: 'nowrap',
    width: '10.25rem',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginRight: '.5rem'
  }
}));

export default useStyles;
